import { MESSAGING } from 'core/datasets/action';
import { isObject, isEmpty } from 'lodash';
import { messagingSelectors } from 'messaging/redux/messagingSelectors';
import { select, put } from 'redux-saga/effects';

export function* updateChannelsMapMetadata(): Generator {
    const channelsMap = yield select(messagingSelectors.channelsMap);

    if (!channelsMap || !isObject(channelsMap) || isEmpty(channelsMap)) {
        yield put({ type: MESSAGING.GET_CHANNELS_MAP });

        return;
    }

    for (const channelId in channelsMap) {
        yield put({
            type: MESSAGING.ADD_CHANNEL_KEY,
            payload: channelId,
        });
    }
}
